import React, { useEffect } from 'react';
import './App.css';
import YatzyGameManager from './components/YatzyGameManager';
import UpdateNotifier from './components/UpdateNotifier';
import InstallPrompt from './components/InstallPrompt';
import { scheduleDailyReminders } from './utils/notifications';
import { initUmami } from './utils/umami';
import { VersionProvider } from './context/VersionContext';
import { TooltipProvider } from './context/TooltipContext';
import { ToastProvider } from './context/ToastContext';
import TooltipLayer from './components/Tooltip';
import { ToastContainer } from './components/ToastContainer';
import { ensureThemeApplied } from './utils/themeManager';

function App() {
  useEffect(() => {
    // CHANGE (2026-08-14): Ingen permission-prompt vid appstart längre – frågan
    // ställs efter första avslutade spelet (YatzyGame). Här schemaläggs bara
    // påminnelser för användare som redan sagt ja.
    if ('Notification' in window && Notification.permission === 'granted') {
      scheduleDailyReminders();
    }
    initUmami();
  }, []);

  // Säkerställ att tema appliceras vid mount
  useEffect(() => {
    ensureThemeApplied();
  }, []);

  return (
    <VersionProvider>
      <TooltipProvider>
        <ToastProvider>
          <div className="App">
            <YatzyGameManager />
            <UpdateNotifier />
            <InstallPrompt />
            <ToastContainer />
          </div>
          <TooltipLayer />
        </ToastProvider>
      </TooltipProvider>
    </VersionProvider>
  );
}

export default App;
